
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { SidebarSeparator } from "@/components/ui/sidebar";
import { useSession } from "@/hooks/use-session";

export const AdminSidebarHeader = () => {
  const { session } = useSession();
  const userEmail = session?.user?.email;
  const userInitials = userEmail ? userEmail.charAt(0).toUpperCase() : 'A';

  return (
    <div className="p-4">
      <div className="flex items-center space-x-3">
        <Avatar>
          <AvatarFallback className="bg-primary text-primary-foreground">
            {userInitials}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <span className="text-sm font-medium">Admin</span>
          <span className="text-xs text-gray-500">{userEmail}</span>
        </div>
      </div>
      <SidebarSeparator className="mt-4" />
    </div>
  );
};
